import $ from 'jquery'
import _ from 'lodash'

/**
 * Calculates the length of a piece of text at a location in the dom. It does
 * not change the context element. The text argument is optional and if not
 * specified will be determined by the context element.
 */

var textLength = function(context, text) {
	$('#text-length').remove()
	context = $(context)

	if(!text) {
		text = context.val()
		if(!text) {
			text = context.html()
		}
	}

	var testEl = $('<div id="text-length">' + _.escape(text) + "</div>")

	var styles = {}
	var computedStyles = window.getComputedStyle(context[0])
	for(var key in computedStyles) {
		// we're iterating over the keys because lodash's keys() and extend()
		// methods don't copy over all the keys in FF
		if(!isNaN(key)) {
			// getComputedStyle returns an object where theres a numeric key for
			// every property (the property name is the value)
			continue
		}
		var val = computedStyles[key]
		if(typeof val === 'function') {
			// let's not apply a function as style
			continue
		}
		if(!val || !val.indexOf) {
			// if the value is null or not a string, don't apply it
			continue
		}
		if(val.indexOf(';') > -1) {
			// this is some sort of cssText style that messes us up
			continue
		}
		if(key.toLowerCase().indexOf('width') > -1) {
			// skip!
			continue
		}
		if(key.toLowerCase().indexOf('padding') > -1) {
			// we need to look for padding in general because there are browsers
			// prefixed property that will effect the padding
			val = '0px'
		}
		testEl.css(key, val)
	}

	// we'll also need to add some styles to position the box so that the user
	// can't see it
	styles.position = 'fixed'
	styles.left = '-10000px'
	styles.top = '0';
	styles.width = 'auto'
	styles.right = 'auto'
	testEl.css(styles)

	testEl.appendTo('body')

	var clientWidth = testEl[0].clientWidth
	testEl.remove()
	return clientWidth
}

export default textLength

textLength.__filename__ = 'components/text-length.js'
